import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import RightArrowIcon from '../icons/right_arrow.svg';

const ModelContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const ModelRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

const ModelLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#4A5568',
  minWidth: 120,
}));

const BarContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 8,
  backgroundColor: '#E2E8F0',
  borderRadius: 4,
  margin: '0 12px',
  overflow: 'hidden',
}));

const Bar = styled(Box)<{ width: number }>(({ theme, width }) => ({
  height: '100%',
  backgroundColor: '#6B46C1',
  width: `${width}%`,
  borderRadius: 4,
}));

const ModelCount = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#1A202C',
  minWidth: 30,
  textAlign: 'right',
}));

const SeeAllLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  color: '#6B46C1',
  textDecoration: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const ArrowIcon = styled('img')(({ theme }) => ({
  width: 12,
  height: 12,
}));

const AIModelSummary: React.FC = () => {
  const models = [
    { label: 'Orchestrator Model', count: 1, percentage: 8 },
    { label: 'Maintenance Model', count: 13, percentage: 100 },
    { label: 'Compliance Engine', count: 2, percentage: 15 },
    { label: 'Predictive Cash flow Forecasting', count: 12, percentage: 92 },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        AI Model Inference Summary
      </Typography>
      {models.map((model, index) => (
        <ModelContainer key={index}>
          <ModelRow>
            <ModelLabel>{model.label}</ModelLabel>
            <BarContainer>
              <Bar width={model.percentage} />
            </BarContainer>
            <ModelCount>({model.count})</ModelCount>
          </ModelRow>
        </ModelContainer>
      ))}
      <SeeAllLink href="#" sx={{ mt: 2 }}>
        See All
        <ArrowIcon src={RightArrowIcon} alt="Arrow" />
      </SeeAllLink>
    </Box>
  );
};

export default AIModelSummary; 